import React, { useState } from 'react';
import './Header.css';

import logoImage from '../assets/images/logo/logo.webp';

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMenuOpen(false);
    }
  };

  return (
    <header className="header">
      <div className="header-container">
        <div className="logo">
            <img src={logoImage} alt="Logo" />
        </div>
        
        <button 
          className={`menu-toggle ${menuOpen ? 'active' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav className={`nav ${menuOpen ? 'active' : ''}`}>
          <button onClick={() => scrollToSection('home')}>HOME</button>
          <button onClick={() => scrollToSection('sobre')}>SOBRE</button>
          <button onClick={() => scrollToSection('servicos')}>SERVIÇOS</button>
          <button onClick={() => scrollToSection('galeria')}>GALERIA</button>
          <button onClick={() => scrollToSection('depoimentos')}>DEPOIMENTOS</button>
          <button onClick={() => scrollToSection('contato')}>CONTATO</button>
        </nav>
      </div>
    </header>
  );
}

export default Header;
